const Tables = {
    ApiCache: 'ufe_api_cache',
    Cache: 'ufe_cache'
};

export default Tables;
